<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-balance-scale mr-2"></i>A. AVISO LEGAL. CONDICIONES DE USO
            </template>
            <ol>
                <li>La utilización de este espacio web está sujeta a la aceptación plena por parte del Usuario de
                    estas Condiciones de Uso, o bien de aquellas que se encuentren vigentes en cada momento en que el
                    usuario acceda al mismo.
                </li>
                <li>Sólo se permite el acceso a este sitio, así como su uso con fines lícitos, ajustándose en todo
                    momento su uso a las presentes Condiciones de uso, la ley aplicable en cada momento, así como la
                    moral, buenas costumbres y orden público. Los gestores del proyecto Eficacia y seguridad del Factor
                    VIII recombinante (NovoEight®) en pacientes con hemofilia A que van a sometidos a intervenciones
                    quirúrgicas (HEMOCIR) se reservan el derecho a retirar el acceso a este sitio, sin necesidad de
                    previo aviso, a cualquier usuario que contravenga lo dispuesto en este aviso legal, así como a poner
                    en conocimiento de las autoridades competentes la realización de actividades que pudiesen ser
                    constitutivas de delito.
                </li>
                <li>Los gestores del Proyecto HEMOCIR se reservan el derecho unilateral de modificar en cualquier
                    momento las presentes Condiciones Generales de Uso así como cualesquiera otras condiciones generales
                    o particulares de su página web. También se reserva el derecho a modificar en cualquier momento la
                    presentación, configuración y localización del Sitio Web, así como los contenidos y las condiciones
                    requeridas para utilizar los mismos.
                </li>
                <li>El Usuario reconoce que el acceso a este sitio se realiza bajo su libre consentimiento y es
                    responsabilidad exclusiva suya.
                </li>
                <li>PROYECTO HEMOCIR se reserva el derecho de poner en conocimiento de la Autoridad competente
                    cualquier otro uso que pueda atentar contra sus intereses o derechos o puedan ser constitutivos de
                    delito.
                </li>
                <li>PROYECTO HEMOCIR se reserva el derecho a poner fin a este servicio web en cualquier momento sin
                    más requisito que el aviso en las presentes condiciones con 15 días de antelación.
                </li>
            </ol>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-balance-scale mr-2"></i>B. CLÁUSULA DE EXCLUSIÓN DE RESPONSABILIDAD
            </template>
            <ol>
                <li>PROYECTO HEMOCIR no puede garantizar la disponibilidad permanente del servicio que ofrece este
                    sitio, ni se hace responsable de cualesquiera daños y perjuicios producidos o que puedan producirse
                    en el futuro, ni de los defectos técnicos, cualquiera que sea su naturaleza, que se deriven del uso
                    de la información contenida en el Web este sitio.
                </li>
                <li>En el caso de que, por un ataque informático, se produjesen errores en la información facilitada,
                    PROYECTO HEMOCIR no se hace responsable de tales errores, así como de los daños causados por el uso
                    de la información derivada de dichos errores.
                </li>
                <li>El contenido de esta web es meramente informativo, no haciéndose responsable en ningún momento
                    acerca de los posibles errores producidos en su presentación. Si desea información más detallada,
                    puede ponerse en contacto a través de la dirección de correo contact+hemocir@lapisoft.es.
                </li>
            </ol>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-balance-scale mr-2"></i>C. RÉGIMEN DE PROPIEDAD INDUSTRIAL E INTELECTUAL
            </template>
            <ol>
                <li>La propiedad industrial e intelectual de cuantos logos, emblemas, o cualquier elemento
                    incorporado en el diseño de este sitio pertenece en exclusiva a PROYECTO HEMOCIR. El Usuario
                    reconoce y acepta estos derechos. Los elementos de esta web sobre los que PROYECTO HEMOCIR no tiene
                    derechos de propiedad intelectual o industrial son usados con el correspondiente permiso.
                </li>
                <li>Queda prohibida la reproducción de todo o parte del contenido de www.hemocir.com así como su
                    transmisión o registrado por ningún sistema de recuperación de información, en ninguna forma ni en
                    ningún medio, a menos que se cuente con la autorización previa, por escrito, de PROYECTO HEMOCIR
                </li>
                <li>No está permitido eludir el copyright sobre los derechos de PROYECTO HEMOCIR, así como eludir o
                    tratar de eludir los sistemas que haya o pueda haber de protección de los contenidos. Se permite el
                    derecho de cita siempre que se indique la fuente de la que proviene.
                </li>
                <li>Cualquier violación de los derechos de propiedad intelectual o industrial de este portal o los
                    elementos de PROYECTO HEMOCIR, será objeto de las oportunas medidas legales para lograr la
                    protección de éstos.
                </li>
            </ol>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-balance-scale mr-2"></i>D. LEGISLACIÓN APLICABLE
            </template>
            <ol>
                <li>PROYECTO HEMOCIR informa que este sitio web se encuentra alojado en España, país en el que ofrece
                    sus servicios, y por ello la única legislación aplicable para resolver cualquier conflicto respecto
                    a la interpretación de estas condiciones, es la legislación española, así como los Tratados
                    Internacionales que haya suscrito España.
                </li>
                <li>Mediante la aceptación de las presentes Condiciones Generales, el usuario se somete a la
                    jurisdicción de los Tribunales de la ciudad de A Coruña, para resolver cualquier controversia
                    relacionada con el apartado anterior.
                </li>
            </ol>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-balance-scale mr-2"></i>E. CÓMO PONERSE EN CONTACTO
            </template>
            <ul>
                <li>
                    Si desea aclarar cualquier aspecto acerca de las condiciones de uso descritas, puede dirigirse a la
                    siguiente dirección de mail: contact+hemocir@lapisoft.es
                </li>
            </ul>
        </b-card>

    </b-container>
</template>

<script>
    export default {
        name: "LegalNotePage"
    };
</script>

<style scoped>

</style>